import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const RotatingImage = ({ images, interval = 6000, className = "", alt = "" }) => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % images.length), interval);
    return () => clearInterval(id);
  }, [images.length, interval]);

  return (
    <div className={`overflow-hidden ${className}`} data-testid="rotating-image">
      <AnimatePresence mode="sync">
        <motion.img
          key={idx}
          src={images[idx]}
          alt={alt}
          initial={{ opacity: 0, scale: 1.06 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            opacity: { duration: 1.3, ease: "easeInOut" },
            scale: { duration: interval / 1000, ease: "linear" },
          }}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </AnimatePresence>
    </div>
  );
};
